/**
 * 「VoIPオプション」の「利用ステータス」の定義値。
 */
export namespace VoipOptionUseStatus {
  /** 1：未申込 */
  export const NONE = '1';
  /** 2：手続中 */
  export const ENTRY = '2';
  /** 3：利用中 */
  export const SERVICE = '3';
  /** 4：解約済 */
  export const QUIT = '4';
  /** 5：解約中 */
  export const QUIT_WITHOUT = '5';
}
